import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_FI.json';
import audios from './ASTROLOGY_AUDIOS_FI.json';

export const ASTROLOGY_DATA_FI: ServiceData = {
  articles,
  audios,
};
